export default __webpack_public_path__ + "static/media/dragon-fight-woodcut.d1deab1e.png";